
export class EpDevPApiRoutesFactoryBase {

  public static validateRoute = ({ pluginId, actualRoute, expectedRoute}:{
    pluginId: string;
    actualRoute: string;
    expectedRoute: string;
  }) => {
    if(actualRoute !== expectedRoute) throw new Error(`${pluginId}: mismatching routes: actualRoute=${actualRoute}, expectedRoute=${expectedRoute}`);
  }
  
}

